<h2 mat-dialog-title>Dat Metadata Mapping Run Report</h2>
<mat-dialog-content style="max-height: 80vh; overflow: auto; margin-top: 20px;">
  <div [innerHTML]="data | markdownToSafeHtml">
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="close()" style="min-width: 60px;">Close</button>
</mat-dialog-actions>
